"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONVERSION_STEP_REMOVE_TARGET_TYPES = [
    'elements',
    'attributes',
];
exports.CONVERSION_STEP_REMOVE_ATTRIBUTE_STRATEGY_TYPES = [
    'blacklist',
    'whitelist',
];
exports.ADJACENT_INSERTION_POSITIONS = [
    'beforebegin',
    'afterbegin',
    'beforeend',
    'afterend',
];
exports.OSMOSYS_MESSAGE_TYPES = [
    'ad',
    'email',
    'context',
    'hostedFile',
    'unknown',
    'accessKey',
    'emailList',
    'workflow',
    'currentUser',
    'emailCampaign',
    'emailTemplate',
    'emailTemplateVersion',
];
//# sourceMappingURL=definitions.js.map